import React, { useEffect, useState } from "react";
import { InputGroup, Form, Spinner } from "react-bootstrap";
import { MdLocationPin } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";

const SupplierCard = ({ supplier, handleProfile }) => {
  const [showAll, setShowAll] = useState(false);

  const supportedProducts = supplier.supported_products || [];
  const visibleProducts = showAll
    ? supportedProducts
    : supportedProducts.slice(0, 2);
  const remainingCount = supportedProducts.length - 2;

  return (
    <div className="col-md-4 mb-3">
      <div className="card supplier-card h-100">
        <div className="card-body d-flex flex-column">
          {/* Supplier Info */}
          <h6 className="card-title text-capitalize">
            {supplier.company_name || "—"}
          </h6>
          <p>
            <MdLocationPin style={{ color: "GrayText" }} />{" "}
            {supplier.address || "—"}
          </p>

          {/* Supported Products Chips */}
          <div className="rfq-chip-row flex-wrap">
            {visibleProducts.map((p, i) => (
              <div key={i} className="rfq-chip">
                {p.product_name}
              </div>
            ))}

            {remainingCount > 0 && (
              <div
                className="rfq-chip more-chip"
                onClick={() => setShowAll((prev) => !prev)}
              >
                {showAll ? "−" : `+${remainingCount}`}
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="mt-auto d-flex gap-2">
            {/* <button
  className="btn"
  style={{ background: "#d01c4c", color: "white" }}
  onClick={() =>
    window.open(
      `/chat-contact?supplier_id=${supplier.company_profile_id}&name=${encodeURIComponent(
        supplier.company_name
      )}`,
      "_blank"
    )
  }
>
  Contact
</button> */}

            <button
              className="btn btn-outline-secondary"
              style={{ color: "#d01c4c" }}
              onClick={() => handleProfile(supplier)}
            >
              View Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const SupplierList = () => {
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await apicall.get("get_suppliersList");
        if (res.success && res.data) {
          setSuppliers(res.data);
        } else {
          toast.error(res.message || "Failed to fetch suppliers");
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        toast.error("Something went wrong while fetching suppliers");
      } finally {
        setLoading(false);
      }
    };
    fetchSuppliers();
  }, []);

  const handleProfile = (supplier) => {
    navigate("/supplierProfile", { state: { supplier } });
  };

  // Filter suppliers based on search term
  const filteredSuppliers = suppliers?.filter((s) =>
    s.company_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mt-3">
      {/* Header */}
      <div className="mx-1">
        <div className="rfq-header">
          <h4>Suppliers</h4>
        </div>

        {/* Search */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-3">
            <InputGroup style={{ width: "300px" }}>
              <Form.Control
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </div>
        </div>

        {/* Supplier Count */}
        <h6>Showing {filteredSuppliers.length} suppliers</h6>
      </div>

      {/* Loading */}
      {loading && (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {/* Supplier Cards */}
      <div className="row">
        {!loading && filteredSuppliers.length === 0 && (
          <p className="text-center text-muted">No suppliers found.</p>
        )}

        {!loading &&
          filteredSuppliers.map((supplier) => (
            <SupplierCard
              key={supplier.company_profile_id}
              supplier={supplier}
              handleProfile={handleProfile}
            />
          ))}
      </div>
    </div>
  );
};

export default SupplierList;
